module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-63-min.ee95614a.jpg";